import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { FieldMapItem, ModalService, NotificationService } from 'beyond-util';

import * as moment from 'moment';
import { FormCode } from '../../enums/form-code.enum';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { FilterType } from '../../enums/filter-type.enum';
import { MediaPlanService } from '../../services/media-plan.service';
import {
  MEDIA_PLAN_UGOVOR,
  MEDIA_PLAN_PODUGOVOR,
  MEDIA_PLAN_PROGRAM,
  MEDIA_PLAN_PERIOD,
  MEDIA_PLAN_PREGLED,
  MEDIA_PLAN_REZ_DATUM_FILTER,
} from '../../constants/tooltip-messages';
import { DEFAULT_DATE_FORMAT } from '../../constants/date-format';
@Component({
  selector: 'app-media-plan-details',
  templateUrl: './media-plan-details.component.html',
})
export class MediaPlanDetailsComponent implements OnInit {
  @Input() ugovorLookupField: FieldMapItem;
  @Input() programComboField: FieldMapItem;
  @Input() klijentLookupFieldSettings: FieldMapItem;
  @Input() datumOdFieldSettings: FieldMapItem;
  @Input() datumDoFieldSettings: FieldMapItem;
  @Input() isEditMode: boolean;
  @Input() programi: any[];
  @Input() datumOd: any;
  @Input() datumDo: any;
  @Input() primeniDatumNaRezervacije = false;
  @Input() programFilter = false;

  @Input('selectedPodugovorKlijent')
  get selectedPodugovorKlijent(): any {
    return this.klijentPodugovor;
  }

  set selectedPodugovorKlijent(value: any) {
    if (this.isEditMode && value) {
      this.klijentPodugovor = value;
    }
  }

  @Input('selectedUgovor')
  get selectedUgovor(): any {
    return this.ugovor;
  }

  set selectedUgovor(value: any) {
    if (this.isEditMode && value) {
      this.ugovor = value;
    }
  }

  @Input('defaultProgramId')
  get defaultProgramId(): any {
    return this._defaultProgramId;
  }

  set defaultProgramId(value) {
    this._defaultProgramId = value;
    this.onProgramChange({ value: value });
  }

  public _defaultProgramId: any;

  @Output() pregled: EventEmitter<any> = new EventEmitter<any>();
  @Output() fetchEmisije: EventEmitter<any> = new EventEmitter<any>();
  @Output() datumChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() podugovorChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() ugovorChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterRezervacije: EventEmitter<any> = new EventEmitter<any>();

  public order: any = {};
  public ugovor: any;
  public program: any;
  public klijentPodugovor: any;

  public tooltips = {
    MEDIA_PLAN_UGOVOR,
    MEDIA_PLAN_PODUGOVOR,
    MEDIA_PLAN_PROGRAM,
    MEDIA_PLAN_PERIOD,
    MEDIA_PLAN_PREGLED,
    MEDIA_PLAN_REZ_DATUM_FILTER,
  };

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  public FilterType = FilterType;

  get klijentNaziv(): number {
    if (this.ugovor) {
      return this.isEditMode
        ? this.ugovor.BrojPodugovora + '  :  ' + this.ugovor.KupacNaziv
        : this.ugovor.Klijent.NazivImePrezime;
    }
  }

  constructor(
    protected _modalService: ModalService,
    private _notificationService: NotificationService,
    private _rtsService: RtsBackendService,
    private _mpService: MediaPlanService
  ) {}

  ngOnInit() {
    this.order.datumOd = this.datumOd;
    this.order.datumDo = this.datumDo;
    this.defaultProgramId = this._mpService.defaultProgramId;
    if (this.isEditMode) {
      this.onPregled();
    }
  }

  selectUgovorConfirmation(event) {
    if(event.value.ImaAnekse !== null || event.value.ImaAnekse !== undefined) {
      return `${event.value.BrojUgovora} ima anekse, da li ste sigurni da želite njega da selektujete?`;
    }
  }

  onUgovorChangeCheck(event: any) {
      if(event.value.ImaAnekse) {
        this._modalService.openModal(
          this.selectUgovorConfirmation(event),
          response => {
            if (response) {
              this.ugovor = event.value;
              this.klijentPodugovor = null;

              this.checkDefaultPodugovor(this.ugovor.Id);

              this.klijentLookupFieldSettings.lookupInitFilter = [
                { name: 'ugovorId', value: this.ugovor.Id },
                { name: 'jeNewMediaPlan', value: 'true'},
              ];

              this.ugovorChanged.emit({
                ugovor: this.ugovor,
              });
            }
            else {
              this.ugovor = null;
            }
          }
        );
      }
      else {
        this.ugovor = event.value;
        this.klijentPodugovor = null;

        this.checkDefaultPodugovor(this.ugovor.Id);

        this.klijentLookupFieldSettings.lookupInitFilter = [
          { name: 'ugovorId', value: this.ugovor.Id },
        ];

        this.ugovorChanged.emit({
          ugovor: this.ugovor,
        });
      }
  }

  onUgovorChange(event: any) {
    if (!event.value) {
      return;
    }

    this.onUgovorChangeCheck(event);
  }

  checkDefaultPodugovor(ugovorId: any) {
    this._rtsService
      .fetchSettings(
        FormCode.MSUGO_PUGKLI,
        FormName.Podugovor,
        EndpointTypes.AllEntities,
        `?ugovorId=${ugovorId}`
      )
      .subscribe(response => {
        if (response.ServiceData.Data.length === 1) {
          this.klijentPodugovor = response.ServiceData.Data[0];
          this.checkPodugovorTip();
          this.podugovorChanged.emit({
            Podugovor: this.klijentPodugovor,
            PodugovorId: response.ServiceData.Data[0].PodugovorId,
            Spotovi: response.ServiceData.Data[0].Spotovi.length
              ? response.ServiceData.Data[0].Spotovi
              : [],
            program: this.program,
          });
        }
      });
  }

  selectPodugovorConfirmation(event) {
    if(event.value.ImaAnekse !== null || event.value.ImaAnekse !== undefined) {
      return `${event.value.BrojPodugovora} ima anekse, da li ste sigurni da želite njega da selektujete?`;
    }
  }

  onKlijentChangeCheck(event: any) {
    this.klijentPodugovor = event.value;
    if(event.value.ImaAnekse) {
      this._modalService.openModal(
        this.selectPodugovorConfirmation(event),
        response => {
          if (response) {
            this.klijentPodugovor = event.value;
            this.checkPodugovorTip();

            this.podugovorChanged.emit({
              Podugovor: this.klijentPodugovor,
              PodugovorId: event.value.PodugovorId,
              Spotovi: event.value.Spotovi.length ? event.value.Spotovi : [],
              program: this.program,
            });
          }
          else {
            this.klijentPodugovor = null;
            this.podugovorChanged.emit({
              Podugovor: null,
              PodugovorId: null,
              Spotovi: [],
              program: this.program,
            });
          }
        }
      );
    }
    else {
      this.klijentPodugovor = event.value;
      this.checkPodugovorTip();

      this.podugovorChanged.emit({
        Podugovor: this.klijentPodugovor,
        PodugovorId: event.value.PodugovorId,
        Spotovi: event.value.Spotovi.length ? event.value.Spotovi : [],
        program: this.program,
      });
    }
  }

  onKlijentChange(event: any) {
    if (event.value) {
      this.onKlijentChangeCheck(event);
    }
    else {
      return;
    }
  }

  checkPodugovorTip() {
    if (this.klijentPodugovor.TipUgovoraId === 2) {
      this.order.datumOd = this.klijentPodugovor.DatumKreiranja;
      this.order.datumDo = this.klijentPodugovor.DatumIsteka;

      this.fetchEmisije.next({
        datumOd: this.order.datumOd,
        datumDo: this.order.datumDo,
        program: this.program,
      });
    }
  }

  onDatumChange(event: any) {
    const field = event.columnItem.fieldKey;
    if (field === 'datumOd' || field === 'datumDo') {
      if (event.columnItem.fieldKey === 'datumOd') {
        this.order.datumOd = moment(event.value.start).format('YYYY-MM-DD');
      } else {
        this.order.datumDo = moment(event.value.start).format('YYYY-MM-DD');
      }

      this.datumChanged.next(this.order);
    }
  }

  onPregled() {
    if (!this.ugovor || !this.program || !this.klijentPodugovor) {
      this._notificationService.notyError(
        'Potrebno je izabrati ugovor, podugovor i program.'
      );

      return;
    }

    const datumOd = moment(this.order.datumOd).format(DEFAULT_DATE_FORMAT);
    const datumDo = moment(this.order.datumDo).format(DEFAULT_DATE_FORMAT);

    this.pregled.next({
      ugovor: this.ugovor,
      podugovor: this.klijentPodugovor,
      program: this.program,
      datumOd,
      datumDo,
    });
  }

  onProgramChange(event: any) {
    this.program = this.programi.find(program => program.Id === event.value);
  }

  toggleRezervacije(type: FilterType) {
    this.filterRezervacije.next(type);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/media-plan-details/media-plan-details.component.ts